const appConfig = window.appConfig || {};

export const config = {
    sentryDsn: appConfig.sentryDsn,
    release: appConfig.release,
};
